export default __webpack_public_path__ + "static/media/ANALOG logo 1.01e259bd.svg";